export const EDITOR_OPTIONS = {
  baseUrl: 'form-builder',
  theme: 'vs',
  language: 'json',
  minimap: {
    enabled: false
  },
  lineNumbers: 'off',
  scrollBeyondLastLine: false,
  automaticLayout: true
};
